module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-this-week.svg?7835bffc55ce968420bbb765f5fa41e9";